const axios = require('axios').default;

/* USERSYSTEM CONTROLLER */
export async function getUserSystems() {
    var result = await axios.get(`UserSystem`);
    return result.data;
}

export async function updateUserSystems(userSystems) {
    await axios.put(`UserSystem`, userSystems);
}

export async function getUserSystemById(id) {
    var result = await axios.get(`UserSystem/${id}`);
    return result.data;
}

/* ACCOUNT CONTROLLER */

export async function registerUser(user) {
    return new Promise((resolve, reject) => {
        axios.post(`Account/register`, user)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export async function loginUser(user) {
    return axios.post(`Account/login`, user);
}

export async function getUserData() {
    var result = await axios.get(`Account`);
    return result.data;
}

export async function getUserById(id) {
    var result = await axios.get(`Account/${id}`);
    return result.data;
}

export async function updateUserPhoto(id, photoObject) {
    return new Promise((resolve, reject) => {
        axios
            .put(`Account/${id}/image`, photoObject, {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export async function getUserPhoto(id) {
    var result = await axios.get(`Account/${id}/image`, { responseType: 'blob' });
    return result;
    // return new Promise((resolve, reject) => {
    //     axios
    //         .get(`Account/${id}/image`, { responseType: 'blob' })
    //         .then(response => {
    //             resolve(response);
    //         })
    //         .catch(error => {
    //             reject(error);
    //         });
    // });
}

export async function changePassword(dto) {
    return new Promise((resolve, reject) => {
        axios.post(`Account/reset/password`, dto)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export async function getSystemDevices(id) {
    var result = await axios.get(`System/${id}/devices`);
    return result.data;
}

export async function deleteUser(id) {
    await axios.delete(`Account/${id}`)
}

export async function deleteOwnAccount() {
    await axios.delete(`Account/own`);
}

export async function updateCurrentUserData(data) {
    await axios.put(`Account`, data);
}

export async function updateUserAccountData(data) {
    await axios.put(`Account/update`, data);
}

export async function restorePassword(data) {
    await axios.put(`Account/restore/password`, data)
}

export async function deleteDevice(id) {
    await axios.delete(`Device/${id}`);
}

export async function getAllUsers() {
    var result = await axios.get(`Account/all`);
    return result.data;
}

export async function getAllUsersNames() {
    var result = await axios.get(`Account/names`);
    return result.data;
}

export async function getSystemUsersNames(systemId) {
    var result = await axios.get(`Account/systemnames/${systemId}`);
    return result.data;
}

export async function updateUserRole(id, role) {
    await axios.put(`Account/${id}/${role}`);
}

export async function removeUserRoles(id) {
    await axios.put(`Account/${id}/role/remove`);
}

/* ROLE CONTROLLER */

export async function getRoles() {
    var result = await axios.get(`Role`);
    return result.data;
}

/* ALARM CONTROLLER */

export async function getAlarmsByIdAndDay(id, day) {
    var result = await axios.get(`Alarm/${id}/${day}`);
    return result.data;
}

export async function getAlarmsForDetailsModal(alarmTypeId, systemId, deviceId, day) {
    var result = await axios.get(`Alarm/${alarmTypeId}/${systemId}/${deviceId}/${day}`);
    return result.data;
}

export async function getAlarmsOverview() {
    var result = await axios.get(`Alarm/overview`);
    return result.data;
}

export async function getAlarmsOverviewForSystem(systemId) {
    var result = await axios.get(`Alarm/overview/${systemId}`)
    return result.data
}

export async function dismissAllAlarms(id) {
    await axios.put(`Alarm/${id}/alarms/dismiss/all`);
}

export async function getAlarmsCount() {
    var result = await axios.get(`Alarm/count`);
    return result.data;
}

export async function getAlarmFilters() {
    var result = await axios.get(`Alarm/filters`);
    return result.data;
}

export async function getLastWeekAlarmsForSystem(systemId, deviceId, alarmTypeId) {
    var result = await axios.get(`Alarm/lastWeek/${systemId}/${deviceId}/${alarmTypeId}`);
    return result.data;
}

export async function changeAlarmState(id, state) {
    await axios.put(`Alarm/${id}/${state}`);
}

export async function deleteAlarm(id) {
    await axios.delete(`Alarm/${id}`);
}

export async function getSystemAlarmsByPriorityFromWeek(systemId, priority) {
    var result = await axios.get(`Alarm/lastWeek/systems/${systemId}/${priority}`)
    return result.data
}

export async function getLastWeekAlarmsForSystemPerDevice(deviceId, from, to) {
    var result = await axios.get(`Alarm/lastWeek/perDevice/${deviceId}/${from}/${to}`)
    return result.data
}

/* ALARM GROUP CONTROLLER */

/* ALARM TYPE CONTROLLER */

export async function getAllAlarmTypes() {
    var result = await axios.get(`AlarmType/all/toShow`)
    return result.data
}

export async function getAllAlarmTypesFaq() {
    var result = await axios.get(`AlarmType/all`)
    return result.data
}

export async function getAllAlarmTypesForSystem(systemId, from, to) {
    var result = await axios.get(`AlarmType/count/${systemId}/${from}/${to}`)
    return result.data
}

export async function updateSendToMobileStatus(id, sendToMobile) {
    await axios.put(`alarmType/isSendToMobile/${id}/${sendToMobile}`);
}

export async function updateSendPushStatus(id, sendPush) {
    await axios.put(`alarmType/isSendPush/${id}/${sendPush}`);
}

export async function getNotDisabledAlarmTypesForSystem(systemId) {
    var response = await axios.get(`AlarmType/notDisabled/${systemId}`)
    return response.data
}

/* DEVICE CONTROLLER */

export async function getDeviceAlarms(id) {
    var result = await axios.get(`Device/alarms/${id}`);
    return result.data;
}

export async function getDeviceAlarmFromDay(deviceId, type, day) {
    var result = await axios.get(`Device/alarms/${deviceId}/${day}/${type}`)
    return result.data
}

export async function getDevicesForSystem(systemId, from, to) {
    var result = await axios.get(`Device/system/${systemId}/${from.toISOString()}/${to.toISOString()}`)
    return result.data
}

/* DEVICE HISTORY CONTROLLER */

export async function getSoftwareHistoryForDevice(deviceId) {
    let result = await axios.get(`Device/software/history/${deviceId}`)
    return result.data
}

/* DEVICE TYPE CONTROLLER */

/* FARM CONTROLLER */

export async function getAllFarmsNames() {
    var result = await axios.get(`System/farmNames`);
    return result.data;
}

export async function getFarms() {
    var result = await axios.get(`System/farms`);
    return result.data
}

/* CONTACT FORM CONTROLLER */

export async function getContactInfo(id) {
    var result = await axios.get(`contact/system/${id}`);
    return result.data;
}

export async function updateContactInfo(data) {
    await axios.post(`contact`, data);
}

export async function getContacts() {
    var result = await axios.get(`contact`)
    return result.data;
}

export async function getContactsBySystem(systemId) {
    var result = await axios.get(`contact/system/` + systemId)
    return result.data
}

export async function updatePcUpdate(systemId, status) {
    await axios.put(`contact/${systemId}/${status}`);
}

export async function getSystemsCoordinates(mode) {
    var result = await axios.get(`contact/map/overview/${mode}`)
    return result.data
}

/* SYSTEM CONTROLLER */
export async function getSystemsStatus() {
    var result = await axios.get(`System/dashboard/status`);
    return result.data;
}

export async function getSystems() {
    var result = await axios.get(`System/all`);
    return result.data;
}

export async function getSystemsOverview() {
    var result = await axios.get(`System/overview`)
    return result.data
}

/*
    Possible modes to send (ignoreCase == true):
    > All
    > Active
    > NoMonitoring
    > Working
    > Issues
*/
export async function getSystemsFromMode(mode) {
    var result = await axios.get(`System/overview/mode/${mode == undefined ? 'All' : mode}`)
    return result.data
}

export async function getSystemFarms(onlyMonitoring) {
    var result = await axios.get(`System/overview/${onlyMonitoring == undefined ? false : onlyMonitoring}`)
        .then((response) => {
            return response;
        })
        .catch(function (error) {
            var result = {
                general: 2,
                blackbox: false,
                device: false,
                rapid24h: false,
                photocells: false,
                pressure: false
            };

            return result;
        });

    return result.data;
}

export async function getSystemsWithCountries() {
    var result = await axios.get(`System/countries`)
    return result.data
}

export async function getSystemAlarmFromDay(systemId, priority, day) {
    var result = await axios.get(`System/${systemId}/${day}/${priority}`)
    return result.data
}

export async function getSystemAlarmChartsForWeek(systemId, alarmTypeId, deviceId) {
    var result = await axios.get(`System/chart/week/${systemId}/${alarmTypeId}/${deviceId}`)
    return result.data
}

export async function getSystemFarmById(id) {
    var result = await axios.get(`System/${id}/overview`);
    return result.data;
}

export async function deleteSystem(id) {
    await axios.delete(`System/${id}`);
}

export async function getSystem(id) {
    var result = await axios.get(`System/${id}`);
    return result.data;
}

export async function updateSystem(data) {
    await axios.put(`System`, data);
}

export async function addSystem(system) {
    await axios.post(`System/create`, system);
}

export async function getSystemImage(imageId) {
    var result = await axios.get(`System/file/${imageId}`, {
        responseType: 'blob'
    });
    return result;
}

export async function addSystemWithDetails(system) {
    await axios.post(`System/add`, system)
}

export async function editSystemWithDetails(system) {
    await axios.put(`System/edit`, system)
}

export async function getSystemStatusList() {
    var result = await axios.get('System/statusDetailsList');
    return result.data;
}

export async function getSystemsStatusList() {
    var result = await axios.get(`System/statusListV2`);
    return result.data;
}

export async function getSystemStatusById(systemId) {
    var result = await axios.get(`System/status/${systemId}`);
    return result.data;
}

export async function getSystemGeneralData(systemId) {
    var result = await axios.get(`System/general/${systemId}`);
    return result.data;
}

export async function getRemoteAccessForSystem(systemId) {
    var result = await axios.get(`System/remoteAccess/${systemId}`);
    return result.data;
}

export async function getRemoteAccessPasswordForSystem(remoteAccessId, pin) {
    // PIN w ciele żądania (nie w URL) — bezpieczniejsze (URL trafia do logów/historii).
    var result = await axios.post(`System/remoteAccess/password/${remoteAccessId}`, { pin });
    return result.data;
}

export async function addRemoteAccess(remoteAccess) {
    await axios.post(`System/remoteAccess`, remoteAccess)
}

export async function editRemoteAccess(remoteAccess) {
    await axios.put(`System/remoteAccess/access`, remoteAccess)
}

export async function editRemoteAccessPassword(remoteAccess) {
    await axios.put(`System/remoteAccess/password`, remoteAccess)
}

export async function deleteRemoteAccess(remoteAccessId, pin) {
    // PIN w ciele żądania (nie w URL) — bezpieczniejsze (URL trafia do logów/historii).
    await axios.post(`System/remoteAccess/${remoteAccessId}/delete`, { pin })
}

export async function getSystemTypes() {
    var result = await axios.get(`System/systemTypes`);
    return result.data;
}

/* System Status */
export async function getSystemStatus(systemId) {

    try {
        let response = await axios.get(`SystemStatus/${systemId}`)
        response.data.isError = false
        return response.data
    }
    catch (e) {

        var status = {
            isError: true,
        };

        return status;
    }
}

export async function getDeviceStatusFromDatesToChart(system, from, to) {
    let response = await axios.get(`SystemStatus/${system}/${from.toISOString()}/${to.toISOString()}`)
    return response.data;
}

/* SETTINGS CONTROLLER */

export async function getRoughageSettings(systemId) {
    var result = await axios.get(`Settings/blackbox/${systemId}`);
    return result.data;
}

export async function getRoughageSettingsHistory(systemId) {
    var result = await axios.get(`Settings/blackbox/history/${systemId}`);
    return result.data;
}

export async function getSortingSettings(systemId) {
    var result = await axios.get(`Settings/sorting/${systemId}`);
    return result.data;
}

export async function getSortingSettingsHistory(systemId) {
    var result = await axios.get(`Settings/sorting/history/${systemId}`);
    return result.data;
}

/* LOADCELLDATA CONTROLLER */

export async function getLoadCellDataHistory(systemId, deviceId) {
    var result = await axios.get(`LoadCellData/history/${systemId}/${deviceId}`);
    return result.data;
}

/* PDF REPORT */

export async function getPdfAlarmReportBySystemId(reportData) {
    var result = await axios.post(`PdfReport/alarms`, reportData, {
        responseType: 'blob'
    });
    return result;
}

/* SYSTEM ALARMS CONTROLLER */

export async function getSystemAlarms(id, sorts, filter, page, pageSize) {
    var result = await axios.get(`SystemAlarm/alarms/${id}` +
        `?sorts=${sorts}` +
        `${filter == '' ? '' : `&filters=name@=*${filter}`}` +
        `&page=${page}` +
        `&pageSize=${pageSize}`);
    return result.data;
}

export async function getSystemAlarmDetails(systemId, alarmTypeId) {
    var result = await axios.get(`SystemAlarm/${systemId}/${alarmTypeId}`);
    return result.data;
}

/* CONTACT CONTROLLER */
export async function getAllContacts() {
    var result = await axios.get(`contactsData/all`);
    return result.data;
}

export async function getContactsBySystemId(systemId) {
    var result = await axios.get(`contactsData/system/${systemId}`);
    return result.data;
}

export async function getContactById(id) {
    var result = await axios.get(`contactsData/${id}`);
    return result.data;
}

export async function addContact(contact) {
    return new Promise((resolve, reject) => {
        axios.post(`contactsData`, contact)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export async function updateContact(contact) {
    return new Promise((resolve, reject) => {
        axios.put(`contactsData`, contact)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
}

export async function deleteContact(id) {
    await axios.delete(`contactsData/${id}`)
}

/* GROUPS */

export async function getExistingGroups() {
    var result = await axios.get(`groups/list`)
    return result.data
}

export async function assignUserToGroups(userId, groupName) {
    await axios.post(`groups/assign/user/${userId}`, groupName)
}

/* STATISTICS */

export async function getStatisticsForSystem(systemId) {
    var result = await axios.get(`Statistics/${systemId}`);
    return result.data;
}

/* VISITS */

export async function getVisitsForSystem(farmId, mode) {
    var result = await axios.get(`Visits/farm/${farmId}/${mode}`)
    return result.data
}

export async function getVisitsForSystemById(systemId, mode) {
    var result = await axios.get(`Visits/system/${systemId}/${mode}`)
    return result.data
}

export async function getVisits(mode) {
    var result = await axios.get(`Visits/mode/${mode}`)
    return result.data
}

export async function getVisit(id) {
    var result = await axios.get(`Visits/${id}`)
    return result.data
}

export async function editVisit(objectToSave) {
    await axios.put(`Visits/edit`, objectToSave)
}

export async function saveVisit(objectToSave) {
    await axios.post(`Visits/new`, objectToSave)
}

export async function getActiveOrFutureVisitsNames() {
    var result = await axios.get(`Visits/active`)
    return result.data
}

export async function getActiveProblemsForVisit(visitId) {
    var result = await axios.get(`Problem/visit/${visitId}`)
    return result.data
}

export async function getSystemsForFarm(farmId) {
    var result = await axios.get(`System/farms/systems/${farmId}`)
    return result.data
}

export async function getReportForFinishedVisit(visitId) {
    var result = await axios.get(`Report/download/${visitId}`, { responseType: 'blob' })
    return result.data;
}

/* PROBLEMS */

export async function getProblems(mode) {
    var result = await axios.get(`Problem/list/${mode}`)
    return result.data
}

export async function getProblem(problemId) {
    var result = await axios.get(`Problem/id/${problemId}`)
    return result.data
}

export async function getProblemsForSystem(systemId, mode) {
    var result = await axios.get(`Problem/system/${systemId}/${mode}`)
    return result.data
}

export async function saveProblem(objectToSave) {
    await axios.post(`Problem/new`, objectToSave, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export async function editProblem(objectToSave) {
    await axios.post(`Problem/edit`, objectToSave, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export async function getProblemPhotos(resourceId) {
    var result = await axios.get(`Problem/resource/file/${resourceId}`, {
        responseType: 'blob'
    })
    return result
}

export async function deleteResourceFromProblem(id) {
    await axios.delete(`Problem/${id}`)
}

/* SOLUTIONS */

export async function getSolutionsForVisit(visitId) {
    var result = await axios.get(`Solution/visit/${visitId}`)
    return result.data;
}

export async function getSolutionsForProblem(problemId) {
    var result = await axios.get(`Solution/problem/${problemId}`)
    return result.data;
}

export async function GetSystemNames() {
    var result = await axios.get(`System/systemNames`)
    return result.data
}

export async function getSolution(solutionId) {
    var result = await axios.get(`Solution/id/${solutionId}`)
    return result.data
}

export async function saveSolution(form) {
    await axios.post(`Solution/new`, form, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export async function editSolution(form) {
    await axios.post(`Solution/edit`, form, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export async function getSolutions() {
    var result = await axios.get(`Solution/all`)
    return result.data
}

export async function getSolutionResourceById(resourceId) {
    var result = await axios.get(`Solution/resources/file/${resourceId}`, {
        responseType: 'blob'
    })
    return result
}

export async function deleteResourceFromSolution(id) {
    await axios.delete(`Solution/resources/${id}`)
}

export async function deleteSolution(id) {
    await axios.delete(`Solution/${id}`)
}

// tickets
export async function getSystemTickets(id, mode) {
    if (mode == undefined) {
        mode == 'All';
    }
    var result = await axios.get(`Tickets/system/${id}/${mode}`)
    return result.data
}

export async function postNewTicket(ticket) {
    await axios.post(`Tickets/new`, ticket, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export async function closeTicket(ticketId) {
    await axios.put(`Tickets/close/${ticketId}`)
}

export async function getStatusForSystemsTickets(systemId) {
    var result = await axios.get(`Tickets/systemStatus/${systemId}`)
    return result.data
}

export async function readTicket(ticketId) {
    try {
        await axios.put(`Tickets/read/${ticketId}`)
    } catch (ex) {
        console.dir(ex)
    }
}

export async function confirmRequestToClose(ticketId) {
    await axios.put(`Tickets/close/${ticketId}`);
}

export async function denyRequestToClose(ticketId) {
    await axios.put(`Tickets/deny/${ticketId}`);
}

// Messages
export async function getMessagesForTicket(ticketId) {
    var result = await axios.get(`Tickets/messages/${ticketId}`)
    return result.data
}

export async function getMessageResource(resourceId) {
    var result = await axios.get(`Tickets/resource/${resourceId}`, {
        responseType: 'blob'
    })
    return result
}

export async function sendMessage(form) {
    await axios.post(`Tickets/response`, form, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

/* Invitations */
export async function getInvitations() {
    var result = await axios.get(`Invitations/list`)
    return result.data
}

export async function deleteInvitations(invitation, pin) {
    var result = await axios.delete(`Invitations/remove/${invitation}/${pin}`)
    return result
}

export async function disableInvitations(invitations) {
    var result = await axios.put(`Invitations/disable`, invitations)
    return result
}

export async function enableInvitations(invitations) {
    var result = await axios.put(`Invitations/enable`, invitations)
    return result
}

export async function createInvitation(invitation) {
    var result = await axios.post(`Invitations/create`, invitation).catch(err => {
        throw err.response.data.error
    });
    return result;
}

export async function updateInvitation(invitation) {
    var result = await axios.put(`Invitations/update`, invitation).catch(err => {
        throw err.response.data.error
    });
    return result;
}

export async function resendInvitation(invitationId) {
    var result = await axios.post(`Invitations/resend/${invitationId}`);
    return result;
}

// device statistics
export async function getDeviceStatisticsForSystem(systemId, day) {
    var result = await axios.get(`Statistics/devices/${systemId}/${day}`);
    return result;
}

export async function getSystemGeneralAlarms(systemId) {
    var result = await axios.get(`Alarm/general/${systemId}`)
    return result
}

export async function getSystemTasks(systemId, showResolved = false) {
    var result = await axios.get(`Alarm/tasks/${systemId}/${showResolved}`)
    return result
}

export async function dismissAlarms(systemId, obj) {
    var result = await axios.post(`Alarm/dismiss/${systemId}`, obj)
    return result
}

export async function dismissManyAlarms(systemId, obj) {
    var result = await axios.post(`Alarm/dismissMany/${systemId}`, obj)
    return result
}

export async function hasTasks(systemId) {
    var result = await axios.get(`Alarm/tasks/has/${systemId}`)
    return result.data
}

export async function getShortDevicesList(systemId) {
    var result = await axios.get(`Device/short/${systemId}`)
    return result.data
}

export async function getAlarmSystemRules(systemId) {
    var result = await axios.get(`Alarm/rules/${systemId}`)
    return result.data
}

export async function addAlarmSystemRules(obj) {
    var result = await axios.post(`Alarm/rules/add`, obj)
    return result.data
}

export async function turnOnAllAlarmsForSystem(systemId) {
    var result = await axios.post(`Alarm/rules/delete/all/${systemId}`)
    return result.data
}

export async function turnOnAlarmTypeForSystem(obj) {
    var toSend = { Rules: obj }
    var result = await axios.post(`Alarm/rules/delete`, toSend)
    return result.data
}

export async function getSystemSettingsOverview(systemId) {
    var result = await axios.get(`System/settings/overview/${systemId}`)
    return result.data
}

export async function updateSystemAlarmOff(systemId, offObject) {
    await axios.post(`System/alarms/monitoring/system/${systemId}`, offObject)
}

export async function updateSystemCheckupDone(checkupObject) {
    await axios.post(`System/checkup`, checkupObject)
}

export async function getTodayCheckupForSystem(systemId) {
    var response = await axios.get(`System/checkup/${systemId}`)
    return response;
}

export async function getUnknownAnimalWeightAlarmParam(systemId) {
    var result = await axios.get(`Alarm/unknownAnimalWeightAlarmParam/${systemId}`)
    return result.data
}

export async function updateUnknownAnimalWeightAlarmParam(systemId, value) {
    await axios.put(`Alarm/unknownAnimalWeightAlarmParam/${systemId}/${value}`)
}

export async function getCalibrationDateErrorAfterDaysParam(systemId) {
    var result = await axios.get(`System/calibrationDate/error/${systemId}`)
    return result.data
}

export async function updateCalibrationDateErrorAfterDaysParam(systemId, value) {
    await axios.put(`System/calibrationDate/error/${systemId}/${value}`)
}

export async function getHerdWeight(systemId) {
    var result = await axios.get(`Animals/chart/herd/weight/${systemId}`)
    return result.data;
}

export async function getAnimals(systemId) {
    var result = await axios.get(`Animals/overview/animals/${systemId}?systemDate=${new Date().toISOString()}`)
    return result.data;
}

export async function getAnimalWeightChart(systemId, animalId) {
    var result = await axios.get(`Animals/chart/animal/weight/${systemId}/${animalId}/All`);
    return result.data;
}

export async function getAnimalConsumptionChart(systemId, animalId) {
    var result = await axios.get(`Animals/chart/animal/consumption/${systemId}/${animalId}/All`);
    return result.data;
}

export async function getAnimalVisitsChart(systemId, animalId) {
    var result = await axios.get(`Animals/chart/animal/visits/${systemId}/${animalId}/All`);
    return result.data;
}

export async function getSensorsChartData(systemId) {
    var from = new Date();
    from.setDate(from.getDate() - 61);
    from = from.toISOString();
    var to = new Date().toISOString();

    var result = await axios.get(`SystemStatus/chart/sensors/${systemId}/${from}/${to}`);
    return result.data;
}

// CLOUD API

export async function getCloudServers() {
    var result = await axios.get(`Cloud/servers`);
    return result.data;
}

export async function getServerUsers() {
    var result = await axios.get(`Cloud/users/server`);
    return result.data;
}

export async function addServerConfiguration(config) {
    var result = await axios.post(`Cloud/new`, config);
    return result.data;
}

export async function assignServerSystem(systems) {
    await axios.post(`Cloud/assign/systems`, systems);
}

export async function assignServerManager(serverId, userId) {
    await axios.post(`Cloud/assign/manager/${serverId}/${userId}`);
}

export async function deleteServer(serverId) {
    await axios.delete(`Cloud/${serverId}`);
}

export async function getServerSystems(serverId) {
    var result = await axios.get(`Cloud/server/${serverId}/systems`);
    return result.data;
}

export async function getSystemsAvailableForCloud() {
    var result = await axios.get(`Cloud/systems/identifiers`);
    return result.data;
}

export async function updateCloudSystemAssigment(serverId, cloudSystem) {
    await axios.post(`Cloud/assign/system/edit/${serverId}`, cloudSystem)
}

// SOFTWARE UPDATER

export async function getVersionsOverview() {
    var result = await axios.get(`Updater/overview`);
    return result.data;
}

export async function getVersionById(id, config) {
    config.responseType = 'blob';
    var result = await axios.get(`Updater/version/${id}`, config)
    return result;
}

export async function addNewSoftwareVersion(newVersion) {
    var result = await axios.post(`Updater/new`, newVersion);
    return result.data;
}

export async function getSoftwareProducts() {
    var result = await axios.get(`Updater/products`);
    return result.data;
}

export async function getSoftwareVersionInfoById(id) {
    var result = await axios.get(`Updater/info/version/${id}`);
    return result.data;
}

export async function uploadBigSoftwareFileChunk(form) {
    await axios.post(`Updater/upload`, form, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export async function uploadBigSoftwareFile(form, id, config) {
    config.headers = { 'Content-Type': 'multipart/form-data' }
    await axios.post(`Updater/upload/stream/${id}`, form, config)
}

export async function uploadRequirementFile(form, id, config) {
    config.headers = { 'Content-Type': 'multipart/form-data' }
    await axios.post(`Updater/requirements/upload/stream/${id}`, form, config)
}

export async function getSoftwarePlatforms() {
    var res = await axios.get(`Updater/platforms`);
    return res.data;
}

export async function getArchitectures() {
    var res = await axios.get(`Updater/architectures`);
    return res.data;
}

export async function deleteVersion(id) {
    await axios.delete(`Updater/delete/${id}`)
}

export async function editSoftwareVersion(obj) {
    var result = await axios.post(`Updater/edit`, obj);
    return result.data;
}

// Software Shortcuts

export async function getSoftwareShortcutCards() {
    var result = await axios.get(`SoftwareShortcut/cards`);
    return result.data;
}

export async function getSoftwareShortcutById(id) {
    var result = await axios.get(`SoftwareShortcut/${id}`);
    return result.data;
}

export async function addSoftwareShortcut(shortcut) {
    var result = await axios.post(`SoftwareShortcut`, shortcut);
    return result.data;
}

export async function editSoftwareShortcut(shortcut) {
    await axios.put(`SoftwareShortcut`, shortcut);
}

export async function deleteSoftwareShortcut(id) {
    await axios.delete(`SoftwareShortcut/${id}`);
}

// Requirements

export async function addRequirement(obj) {
    var result = await axios.post('Updater/requirements/new', obj);
    return result.data;
}

export async function editRequirement(obj) {
    await axios.post('Updater/requirements/edit', obj);
}

export async function deleteRequirement(id) {
    await axios.delete(`Updater/requirements/delete/${id}`);
}

export async function getRequirementsList() {
    var response = await axios.get(`Updater/requirements/list`);
    return response.data;
}

export async function getRequirementById(id, config) {
    config.responseType = 'blob';
    var response = await axios.get(`Updater/requirement/${id}`, config);
    return response;
}

// BACKUPS

export async function getBackupsOverview() {
    var result = await axios.get(`Backup/overview`);
    return result.data;
}

export async function getBackupById(id, config) {
    config.responseType = 'blob';
    var result = await axios.get(`Backup/${id}`, config)
    return result;
}

export async function deleteBackup(id) {
    await axios.delete(`Backup/delete/${id}`)
}

/* SCHEDULED REPORTS */
// Cykliczne raporty e-mail o alarmach. Nie mylic z PdfReport (raporty serwisowe z wizyt).

export async function getScheduledReports() {
    var result = await axios.get(`ScheduledReport`);
    return result.data;
}

export async function getScheduledReport(id) {
    var result = await axios.get(`ScheduledReport/${id}`);
    return result.data;
}

export async function addScheduledReport(report) {
    var result = await axios.post(`ScheduledReport`, report);
    return result.data;
}

export async function editScheduledReport(report) {
    var result = await axios.put(`ScheduledReport`, report);
    return result.data;
}

export async function deleteScheduledReport(id) {
    await axios.delete(`ScheduledReport/${id}`);
}

export async function previewScheduledReport(id) {
    var result = await axios.get(`ScheduledReport/${id}/preview`, { responseType: 'text' });
    return result.data;
}

export async function sendScheduledReportNow(id) {
    var result = await axios.post(`ScheduledReport/${id}/send-now`);
    return result.data;
}

/* API USAGE CONTROLLER */
// Diagnostyka uzycia API (tylko Admin). Listy (userIds, roles) jako napisy rozdzielane przecinkami.

export async function getApiUsageReport(params) {
    var result = await axios.get(`ApiUsage/report`, { params: params });
    return result.data;
}

export async function getApiUsageTimeline(params) {
    var result = await axios.get(`ApiUsage/timeline`, { params: params });
    return result.data;
}

export async function getApiUsageEndpoints() {
    var result = await axios.get(`ApiUsage/endpoints`);
    return result.data;
}

/* NOTIFICATION CONTROLLER */

export async function getSystemNotifications(systemId) {
    var result = await axios.get(`Notification/system/${systemId}`);
    return result.data;
}

export async function sendNotificationsNow() {
    var result = await axios.post(`Notification/send-now`);
    return result.data;
}



// WEBPACK FOOTER //
// ./src/api/api.js